import React, { Component, Suspense } from "react";
import _ from "lodash";
import Loader from "../../../Global/Loader";
import axios from "axios";
import { Services } from "../../../../repositories/clients/Services";
import { Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import { Tab } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import ContainerWrapper from "../../../template/Layout/ContentWrapper";
import SumaryDetail from "./components/general";
// import Events from "./components/Events";
import Document from "./components/Documents";
import queryString from "query-string";
import { withNamespaces } from "react-i18next";
import RepositoryFactory from "../../../../repositories/RepositoryFactory";
import { validateIdParams } from "../../../utils/regularExpressionValidation";
import createModal from "../../Components/ModalV2";
import { openNotification } from "../../Components/Notification";

import "./styles/styles.scss";

const Comments = React.lazy(() => import("../../Components/Comments"));
const AllComments = React.lazy(() =>
  import("../../Components/Comments/AllComment")
);
const PurchaseOrderRepository = RepositoryFactory.get("PurchaseOrder");
const IMGOrdenes =
  "https://magiclog.blob.core.windows.net/europartnerspic/Icono_Ordenes-de-compra.svg";

class PurchaseOrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalSuccess: false,
      typeModal: "success",
      isMobil: false,
      clientesSelect: this.props.clients
        ? JSON.stringify(this.props.clients)
        : "[0]",
      scrollLine: true,
      tabActive: 0,
      rolId: this.props._rolId,
      userId: this.props._user,
      AllcommentsData: [],
      createFormsData: [],
      isEdit: false,
      createForms: [],
      poInfo: {},
      purchaseOrderId: this.props.match ? this.props.match.params.id : -1,
      info: {},
      allSteps: [],
      newStepsAereoM: [
        {
          value: "",
          label: this.props.t("created"),
          id: 1,
          completed: false,
          order: 1,
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("cargo_ready"),
          value: "",
          id: 5,
          completed: false,
          order: 2,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("planned"),
          value: "",
          id: 6,
          completed: false,
          order: 3,
          middle: false,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("pick_up"),
          value: "",
          id: 8,
          completed: false,
          order: 4,
          middle: false,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },

        {
          label: this.props.t("booking"),
          value: "",
          id: 9,
          completed: false,
          order: 5,
          idStep: "step5",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("departure"),
          value: "",
          id: 12,
          completed: false,
          order: 6,
          idStep: "step6",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("arrival"),
          value: "",
          id: 15,
          completed: false,
          order: 7,
          idStep: "step7",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("delivery"),
          value: "",
          id: 21,
          completed: false,
          order: 8,
          idStep: "step8",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
      ],
      newStepsTerrestre: [
        {
          value: "",
          label: this.props.t("created"),
          id: 1,
          completed: false,
          order: 1,
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("cargo_ready"),
          value: "",
          id: 5,
          completed: false,
          order: 2,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("planned"),
          value: "",
          id: 6,
          completed: false,
          order: 3,
          middle: false,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("pick_up"),
          value: "",
          id: 8,
          completed: false,
          order: 4,
          middle: false,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },

        {
          label: this.props.t("booking"),
          value: "",
          id: 9,
          completed: false,
          order: 5,
          idStep: "step5",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("departure"),
          value: "",
          id: 12,
          completed: false,
          order: 6,
          idStep: "step6",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("arrival"),
          value: "",
          id: 16,
          completed: false,
          order: 7,
          idStep: "step7",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("delivery"),
          value: "",
          id: 21,
          completed: false,
          order: 8,
          idStep: "step8",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
      ],
      infoEmbarque: {},
      loadingInfo: true,
      isEditing: false,
      tablaClientes: "",
      commentsData: [],
      users: [],
      catalogsData: [
        {
          ComTypeId: 1,
          ModuleId: 1,
          ComType: "Supplier Follow Up",
          value: 1,
          label: "Supplier Follow Up",
        },
        {
          ComTypeId: 2,
          ModuleId: 1,
          ComType: "Order Quality",
          value: 2,
          label: "Order Quality",
        },
        {
          ComTypeId: 3,
          ModuleId: 1,
          ComType: "Order Quantities",
          value: 3,
          label: "Order Quantities",
        },
        {
          ComTypeId: 10,
          ModuleId: 1,
          ComType: "Other",
          value: 10,
          label: "Other",
        },
      ],
    };
  }

  componentDidMount = async () => {
    this.validateParamId();
    const details = navigator.userAgent;
    const regexp = /android|iphone|kindle|ipad/i;
    const isMobileDevice = regexp.test(details);
    this.setState({
      isMobil: isMobileDevice,
    });
    const isNotify = queryString.parse(this.props.location.search);
    let notifyActiveComment = false;
    if (isNotify.nofify) {
      notifyActiveComment = true;
    }
    await this.getPurchaseOrder(notifyActiveComment);
    this.getCommets(notifyActiveComment);
  };

  validateParamId = () => {
    const { purchaseOrderId } = this.state;
    const idValidate = validateIdParams(purchaseOrderId);
    if (!idValidate) {
      openNotification("error", this.props.t("Data_entered_is_invalid"));
      setTimeout(() => {
        this.props.history.push("/po-management");
      }, 2000);
      return;
    }
  };

  getCommets = (NewComments, notifyActiveComment) => {
    let { CustomerId, POId } = this.state.poInfo;
    let moduleId = 10;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    axios
      .get(
        `${Services.ORDEN_SERV.path}orderComents/get-comment?rowid=${POId}&moduleid=${moduleId}&general=true&zona=${timezone}&lang=${this.props.lng}`
      )
      .then((response) => {
        const comentario = response.data.Comment;
        const AllcommentsData = response.data.CommentGeneral;
        this.setState({
          AllcommentsData: AllcommentsData,
          scrollLine: NewComments,
        });
        this.getUserMenciones(
          comentario,
          CustomerId,
          POId,
          this.state.poInfo,
          AllcommentsData
        );

        if (notifyActiveComment) {
          openNotification("success", notifyActiveComment);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getUserMenciones = (
    comentario,
    CustomerId,
    ShipmentId,
    item,
    notifyActiveComment
  ) => {
    let { userId } = this.state;

    axios
      .get(
        `${Services.ORDEN_SERV.path}orderComents/getUserMension?CustomerId=${CustomerId}&user=${userId}`
      )
      .then((response) => {
        this.setState({
          commentsData: comentario,
          users: response.data.data,
          rowid: ShipmentId,
          itemCommenSelect: item,
          loadercomments: false,
          // tabActive: notifyActiveComment ? 1 : 0,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentWillReceiveProps = (nextProps) => {
    const isNotify = queryString.parse(nextProps.location.search);
    let notifyActiveComment = false;
    const newProp = nextProps.match.params.id || this.props.match.params.id;

    this.setState(
      {
        newSelected: [],
        selectcheck: false,
        Form: nextProps.form,
        reset: true,
      },
      () => {
        if (isNotify.nofify) {
          notifyActiveComment = true;
          this.setState(
            {
              purchaseOrderId: newProp,
              loadingInfo: true,
            },
            () => {
              this.getPurchaseOrder(notifyActiveComment);
              this.getCommets(notifyActiveComment);
            }
          );
        }

        // this.getRoles();
        // this.getUser();
      }
    );
  };
  getPurchaseOrder = async (notifyActiveComment) => {
    try {
      const { tempInfo, purchaseOrderId, userId } = this.state;
      const purchaseInfo = await PurchaseOrderRepository.getPO(
        purchaseOrderId,
        userId,
        this.props.lng
      );
      let dataPo = purchaseInfo.data;
      dataPo.pickupAddressConcatenated = `${dataPo.PickupAddress}, ${dataPo.OriginZipCode}`;
      dataPo.DeliveryAddressPOConcatenated = `${dataPo.DeliveryAddressPO}, ${dataPo.DestinationZipCode}`;
      if (!dataPo) throw new Error("No data");
      this.setState(
        {
          poInfo: dataPo,
          tempInfo,
          loadingInfo: false,
          tabActive: notifyActiveComment ? 1 : 0,
        },
        () => {
          this.getEvents();
        }
      );
    } catch (error) {
      console.log("getPurchaseOrderError", error);
      openNotification("error", this.props.t("Data_entered_is_invalid"));
      setTimeout(() => {
        this.props.history.push("/po-management");
      }, 2000);
    }
  };

  actualiza = async (newPO) => {
    const { purchaseOrderId, userId } = this.state;
    this.setState({ isEditing: false, loadingInfo: true }, async () => {
      try {
        const updatePO = {
          ...newPO,
          POId: purchaseOrderId,
          UserId: userId,
        };
        await Promise.all([
          PurchaseOrderRepository.updatePO(updatePO),
          PurchaseOrderRepository.updatePOCustomerEntities(updatePO),
        ]);

        this.setState({
          modalSuccess: true,
          typeModal: "success",
          messageModal: this.props.t("purchase_order_successfully_updated"),
        });
        // modal de actualizar
        // Swal.fire({
        //   icon: "success",
        //   confirmButtonColor: "#0561fc",
        //   confirmButtonText: "Ok",
        //   html: `<div class="text-center euro-title-form">
        //   ${this.props.t("purchase_order_successfully_updated")}
        //   </div>`,
        //   customClass: {
        //     confirmButton: 'custom-width-btn swal'
        //   }
        // });
        this.getPurchaseOrder();
      } catch (error) {
        console.log("🚀 ~ PurchaseOrderDetail ~ this.setState ~ error:", error);
        this.setState({
          modalSuccess: true,
          typeModal: "error",
          messageModal: this.props.t("purchase_order_error_updated"),
          loadingInfo: false,
        });

        // console.log("updatePOError", error);
        // Swal.fire({
        //   icon: "error",
        //   confirmButtonColor: "#0561fc",
        //   confirmButtonText: "Ok",
        //   html: `<div class="text-center euro-title-form">
        //   ${this.props.t("purchase_order_error_updated")}
        //   </div>`,
        //   customClass: {
        //     confirmButton: 'custom-width-btn swal'
        //   }
        // });
        // this.setState({ loadingInfo: false });
      }
    });
  };

  editar = () => {
    const { isEditing } = this.state;
    this.setState({ isEditing: !isEditing });
  };

  showLoad = () => {
    this.setState({ loadingInfo: true });
  };

  finishLoad = () => {
    this.setState({ loadingInfo: false });
  };

  getEvents = () => {
    const { purchaseOrderId, newStepsAereoM, newStepsTerrestre, info } =
      this.state;
    axios
      .get(
        `${Services.PURCHASE_ORDER.path}purchaseOrder/poEvents/${purchaseOrderId}?lang=${this.props.lng}`
      )
      .then((response) => {
        let update = false;
        for (let index = response.data.steps.length; index >= 0; index--) {
          const element = response.data.steps[index];
          if (element && element.completed) update = true;
          if (update) element.completed = true;
        }
        let dataEvents = response.data.data;
        let findNext = false;
        //Road 3
        let newSteps =
          info.TransportModeId === 3 ? newStepsTerrestre : newStepsAereoM;
        newSteps.map((f) => {
          dataEvents.map((e) => {
            if (e.EventDescriptionId === f.id) {
              findNext = true;
              f.value = e.EventDate;
              if (e.InTimeLine === "1") {
                f.completed = true;
              }
            } else {
              findNext = false;
            }
            return e;
          });
          return f;
        });
        newSteps.sort(function (a, b) {
          return b.order - a.order;
        });
        let findTrue = false;
        newSteps.map((e) => {
          if (e.completed) {
            findTrue = true;
          }
          if (findTrue) {
            e.completed = true;
          }
          return e;
        });
        newSteps.sort(function (a, b) {
          return a.order - b.order;
        });

        this.setState({
          steps: newSteps,
          allSteps: dataEvents,
          loadingInfo: false,
        });
      });
  };

  cancelar = () => {
    const { isEditing, tempInfo } = this.state;
    this.setState({
      isEditing: !isEditing,
      info: _.cloneDeep(tempInfo),
    });
  };

  tabChange = (evt, data) => {
    if (data.activeIndex > 0) {
      this.setState({ loadingInfo: false, isEditing: false });
    }
  };

  newMessage = async (data) => {
    const { purchaseOrderId, userId } = this.state;
    data.Rowid = purchaseOrderId;
    data.UserId = userId;
    data.ModuleId = 10;

    if (data.Mentions.length > 0) {
      let uniq = [...new Set(data.Mentions)];
      data.Mentions = uniq;
    }

    try {
      await axios.post(
        `${Services.PURCHASE_ORDER.path}purchaseOrderComments/add-comment`,
        data
      );

      const successMsg =
        data.PermanentComment === "1"
          ? this.props.t("po_marked_as_issue_successfully")
          : this.props.t("comment_successfully_saved");

      this.getCommets(false, successMsg);
    } catch (error) {
      console.log(error);
      openNotification("error", "Error al mandar el comentario");
    }
  };

  deleteMessage = async (idDelete, toggle) => {
    axios
      .delete(
        `${Services.PURCHASE_ORDER.path}purchaseOrderComments/delete-comment/${idDelete}`
      )
      .then(() => {
        this.getCommets(false, this.props.t("comment_successfully_deleted"));
        toggle();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    let {
      tabActive,
      loadingInfo,
      isMobil,
      rolId,
      userId,
      commentsData,
      users,
      AllcommentsData,
      modalSuccess,
      messageModal,
    } = this.state;

    if (loadingInfo) return <Loader />;

    return (
      <ContainerWrapper>
        <div className="content-heading">
          <span className="icon-po-management icon-header" />
          {this.props.t("purchase_order")}
          <div className="euro-return-tittle">
            <Icon.Group size="large">
              <Icon
                name="angle left"
                className="_btnBack"
                size="big"
                onClick={() => this.props.history.push("/po-management")}
              />
            </Icon.Group>
            <span
              className="label-back"
              onClick={() => this.props.history.push("/po-management")}
            >
              {this.props.t("back")}
            </span>
          </div>
        </div>
        
          <Tab
            menu={{
              secondary: true,
              pointing: true,
              className: "custom-tab-menu sticky-tabs",
            }}
            onTabChange={(_event, data) => {
              this.setState(
                { tabActive: data.activeIndex },
                () => this.tabChange
              );
            }}
            activeIndex={tabActive}
            panes={[
              {
                menuItem: this.props.t("summary"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    <SumaryDetail
                      rolId={this.props._rolId}
                      steps={this.state.steps}
                      userid={this.props._user}
                      cancelar={this.cancelar}
                      actualiza={this.actualiza}
                      poInfo={this.state.poInfo}
                      isMobil={isMobil}
                      getPO={this.getPurchaseOrder}
                      getComments={this.getCommets}
                      users={users}
                      addComment={this.newMessage}
                    />
                  </Suspense>
                ),
              },
              {
                menuItem: this.props.t("comments"),
                render: () => (
                  // <div>
                  <Suspense fallback={<div>Loading...</div>}>
                    {/* <ContainerWrapper> */}
                      <div class="row">
                        <div class="col-xs-12 col-md-6 col-lg-6">
                          <legend className="legendEuroBold">
                            {this.state.info ? this.state.info.RefCustomer : ""}
                          </legend>
                          <Comments
                            scrollLine={this.state.scrollLine}
                            rolId={rolId}
                            userId={userId}
                            data={commentsData}
                            catalogs={users}
                            funtionNewMessage={this.newMessage}
                            funtionDeleteMessage={this.deleteMessage}
                          />
                        </div>
                        <div class="col-xs-12 col-md-6 col-lg-6">
                          <legend className="legendEuroBold">
                            {this.props.t("related_comments")}
                          </legend>

                          <AllComments data={AllcommentsData} />
                        </div>
                      </div>
                    {/* </ContainerWrapper> */}
                  </Suspense>

                  // </div>
                ),
              },
              {
                menuItem: this.props.t("documents"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    {/* <ContainerWrapper> */}
                      <Document
                        _rolId={this.props._rolId}
                        data={this.state.info}
                        id={this.state.info.ServiceOrderId}
                        _user={this.props._user}
                        isMobil={isMobil}
                        poInfo={this.state.poInfo}
                      ></Document>{" "}
                    {/* </ContainerWrapper>{" "} */}
                  </Suspense>
                ),
              },
            ]}
          />
        
        {createModal({
          isModalOpen: modalSuccess,
          type: "success",
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{messageModal}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: "Ok",
              onClick: () => this.setState({ modalSuccess: false }),
              type: "primary",
            },
          ],
          onCancel: () => this.setState({ modalSuccess: false }),
        })}
      </ContainerWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseOrderDetail))
);
